<p8-settings-page>
  <p8-settings-header [titlePath]="['Pages', 'Editer']"></p8-settings-header>

  <a name="page"></a>
  <p8-bdc-page-form></p8-bdc-page-form>

  <p8-settings-footer>
    <button mat-raised-button
            color="accent"
            [disabled]="pageFormComponent.pageForm && !pageFormComponent.pageForm?.valid"
            (click)="onSubmit()"
    >ENREGISTRER</button>
    <button mat-button (click)="onCancel()">RETOUR</button>
    <!--<mat-divider [vertical]="true"></mat-divider>-->
    <span style="border-left: 1px solid #9a9a9a; height: 36px; margin-right: 24px;"></span>
    <button mat-button (click)="onVisualize()" matTooltip="N'oubliez pas d'enregistrer avant de visualiser">VISUALISER</button>

  </p8-settings-footer>
</p8-settings-page>
